import React from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import { Modal } from '@saucelabs/sl-component-overlay';
import modalConnect from '@saucelabs/sl-container-modal';
import { RemoteSubmit } from '@saucelabs/sl-component-form';

import { CHANGE_EMAIL_FORM, CHANGE_EMAIL_MODAL } from './../ducks/types';
import ChangeEmailForm from './ChangeEmailForm';
import Styles from './ChangeEmailModal.styles';

const ChangeEmailModal = ({
  changeEmail,
  onHide,
  show,
  username,
}) => (
  <Modal
    dialogClassName={`changeEmailModal ${Styles.default}`}
    onHide={onHide}
    show={show}
  >
    <Modal.Header>
      <Modal.Title>Change email address</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ChangeEmailForm
        changeEmail={changeEmail}
        initialValues={{ username }}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button
        category="primary"
        onClick={onHide}
        size="sm"
      >
        Cancel
      </Button>
      <RemoteSubmit
        category="action"
        name={CHANGE_EMAIL_FORM}
        size="sm"
      >
        Save changes and resend email
      </RemoteSubmit>
    </Modal.Footer>
  </Modal>
);


ChangeEmailModal.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
};

export default modalConnect(CHANGE_EMAIL_MODAL, ChangeEmailModal);
export { ChangeEmailModal };
